module.exports = __webpack_public_path__ + "static/media/wheel.9ad76e01.svg";